import styled from 'styled-components';

export const Container = styled.div`
  margin-left: 4.89rem;
  width: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 1024px) {
    margin-left: 0;
    margin-top: 2rem;
  }
`;

export const Title = styled.h1`
  display: flex;
  align-items: center;
  font-family: 'RedHatDisplay-Bold';
  line-height: 3rem;
  margin-bottom: 0.5rem;

  > h1 {
    font-size: 1.56rem;
    color: #1e88e5;
    text-align: center;
    margin-left: 0.6rem;
  }

  @media (max-width: 1024px) {
    justify-content: center;
  }
`;

export const CertificatesSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

export const CertificateCard = styled.div`
  background: #f5f5f5;
  padding: 1rem;
  border-radius: 0.5rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

export const CertificateTitle = styled.h2`
  font-family: 'RedHatDisplay-Bold';
  font-size: 1.2rem;
  color: #323232;
`;

export const CertificateDate = styled.span`
  font-size: 0.9rem;
  color: #666;
`;

export const ActionButtonsDownload = styled.div`
  display: flex;
  gap: 0.5rem;

  button {
    background: #1e88e5;
    color: white;
    border: none;
    padding: 0.5rem 1rem;
    border-radius: 0.25rem;
    cursor: pointer;
    transition: background-color 0.3s;

    &:hover {
      background-color: #1565c0;
    }
  }
`;

export const NoCertificatesMessage = styled.p`
  font-family: 'RedHatDisplay-Regular';
  color: #666;
  text-align: center;
  margin-top: 2rem;
  font-size: 1rem;
`;
